export default "__VITE_ASSET__DYGnskr$__"